module.exports = __webpack_public_path__ + "img/img_bodytype_normal.13471278.png";